import { APP_INITIALIZER } from '@angular/core'
import { FeatureFlagService } from '../services/feature-flag.service'

export const provideFeatureFlag = () => ({
  provide: APP_INITIALIZER,
  useFactory: (featureFlagService: FeatureFlagService) => () => featureFlagService.getFeatureFlags().toPromise(),
  deps: [FeatureFlagService],
  multi: true,
})
